import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleButton from "../../../modules/commons/SimpleButton";
import Api from "../../../Services/Api";
import * as R from "ramda";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleInput from "../../../modules/SimpleInput";
import M from "moment";
import SimpleModal from "../../../modules/popup/SimpleModal";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleDate from "../../../modules/SimpleDate";
import { contructQueryParam, fetchDataAsync } from "../../../Services/Utils";

class MasterPartPriceFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataPart: [],
      dataPartKode: [],
      dataPartNama: [],
      dataMainDealer: [],
      temporaryFilter: {},
      warningMessage: "",
    };
  }

  async componentDidMount() {
    const [responseMainDealer, responsePart] = await Promise.all([
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllSupplierMainDealer,
        menuName: "Master Unit Price",
        setError: this.props.setError,
        args: contructQueryParam({
          kodeCabang: this.props.selectedCabang.value,
        }),
      }),
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterPart,
        menuName: "Master Unit Price",
        setError: this.props.setError,
        args: { paramFilters: { status: "ACTIVE" }, limit: null, page: null },
      }),
    ]);

    if (responseMainDealer.ok && !R.isEmpty(responseMainDealer.data.data)) {
      const partList = responsePart?.data?.data || [];

      this.setState({
        dataMainDealer: responseMainDealer.data.data.map((c) => ({
          label: c.supplierName,
          value: c.supplierCode,
        })),
        dataPart: partList,
        dataPartKode: partList.map((p) => ({
          label: p.kodePart,
          value: p.kodePart,
        })),
        dataPartNama: partList.map((p) => ({
          label: p.partName,
          value: p.partName,
        })),
        temporaryFilter:
          Object.keys(this.props.temporaryFilter).length !== 0
            ? this.props.temporaryFilter
            : {},
      });
    }
  }

  // handleReset = () => {
  //   this.setState({
  //     temporaryFilter: {},
  //   });
  //   this.props.onReset();
  // };

  handleReset = () => {
    const today = M().format("DD-MM-YYYY");
    this.setState({
      temporaryFilter: {},
      warningMessage: "",
    });

    this.props.onReset({
      startEffectiveDate: today,
      endEffectiveDate: today,
      kodeCabang: Array.isArray(this.props.kodeCabang)
        ? this.props.kodeCabang.map((c) => c.value)
        : [],
    });
  };

  handleValueChange = (input, event) => {
    const value = Array.isArray(event)
      ? event.map((item) => item.value)
      : event
      ? event.value
      : "";
    this.setState((prevState) => ({
      ...prevState,
      temporaryFilter: {
        ...prevState.temporaryFilter,
        [input]: value,
      },
    }));
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.onSubmit(this.state.temporaryFilter);
  };

  handleInputDateChange = (name, value) => {
    this.setState(
      (prevState) => ({
        ...prevState,
        temporaryFilter: {
          ...prevState.temporaryFilter,
          [name]: M(value).format("DD-MM-YYYY"),
        },
        warningMessage: "",
      }),
      () => {
        const { startEffectiveDate, endEffectiveDate } =
          this.state.temporaryFilter;
        const parsedFromDate = startEffectiveDate
          ? M(startEffectiveDate, "DD-MM-YYYY").toDate()
          : null;
        const parsedToDate = endEffectiveDate
          ? M(endEffectiveDate, "DD-MM-YYYY").toDate()
          : null;

        if (parsedFromDate && parsedToDate && parsedToDate < parsedFromDate) {
          this.setState({
            warningMessage:
              "Tanggal akhir tidak boleh lebih kecil dari tanggal awal.",
          });
        }
      }
    );
  };

  findLabel = (value, options) => {
    if (!value || options.length === 0) return null;

    if (Array.isArray(value)) {
      return value
        .map((v) => options.find((option) => option.value === v))
        .filter(Boolean);
    }

    return options.find((option) => option.value === value) || null;
  };

  render() {
    const { kodeCabang } = this.props;
    const {
      dataPartKode,
      dataPartNama,
      dataMainDealer,
      temporaryFilter,
      warningMessage,
    } = this.state;

    return (
      <SimpleModal
        title="Filter Unit Motor"
        visible={this.props.visible}
        onClickClose={this.props.onClickClose}
        content={
          <ModalContainer>
            <SimpleInput
              id="input_text_kode_document"
              name="partPriceId"
              label="Kode Dokumen"
              value={temporaryFilter.partPriceId || ""}
              onChange={(e) =>
                this.handleValueChange("partPriceId", {
                  value: e.target.value,
                })
              }
            />

            <FlexView
              vAlignContent="center"
              style={{ alignItems: "center" }}
              marginBottom={10}
              marginTop={15}
            >
              <p
                className="margin-bottom-20px margin-right-10px"
                style={{ textAlign: "center" }}
              >
                Tanggal Berlaku
              </p>
              <SimpleDate
                id="select_date_from"
                date={temporaryFilter?.startEffectiveDate}
                onChange={(value) =>
                  this.handleInputDateChange("startEffectiveDate", value)
                }
              />
              <p
                className="margin-bottom-20px margin-right-10px margin-left-10px"
                style={{ textAlign: "center" }}
              >
                -
              </p>
              <SimpleDate
                id="select_date_to"
                date={temporaryFilter?.endEffectiveDate}
                onChange={(value) =>
                  this.handleInputDateChange("endEffectiveDate", value)
                }
              />
            </FlexView>

            {warningMessage && (
              <p style={{ color: "red", marginTop: "10px" }}>
                {warningMessage}
              </p>
            )}

            <SimpleDDL
              id="input_text_kode_main_dealer"
              name="mdId"
              label="Main Dealer"
              box="search"
              isClearable
              options={dataMainDealer}
              value={this.findLabel(temporaryFilter.mdId, dataMainDealer) || ""}
              onChange={(e) => this.handleValueChange("mdId", e)}
            />

            <SimpleDDL
              id="input_select_kode_cabang"
              name="kodeCabang"
              label="Cabang Berlaku"
              box="multiselect"
              isClearable
              options={kodeCabang}
              value={
                this.findLabel(temporaryFilter.kodeCabang, kodeCabang || []) ||
                ""
              }
              onChange={(e) => this.handleValueChange("kodeCabang", e)}
            />

            <SimpleInput
              id="input_text_kode_part"
              name="kodePart"
              label="Kode Part"
              value={temporaryFilter.kodePart || ""}
              onChange={(e) =>
                this.handleValueChange("kodePart", { value: e.target.value })
              }
            />

            <SimpleInput
              id="input_text_nama_part"
              name="partName"
              label="Nama Part"
              value={temporaryFilter.partName || ""}
              onChange={(e) =>
                this.handleValueChange("partName", { value: e.target.value })
              }
            />

            <FlexView hAlignContent="right">
              <SimpleButton type="button" secondary onClick={this.handleReset}>
                Hapus
              </SimpleButton>
              <SimpleButton type="button" onClick={this.handleSubmit}>
                Terapkan
              </SimpleButton>
            </FlexView>
          </ModalContainer>
        }
      />
    );
  }
}

export default MasterPartPriceFilter;
